export default __webpack_public_path__ + "static/media/Img-Lobo.9f153e34.jpg";